export default {
  seo: {
    title: "Velux reparatie Eindhoven | Dakraam, motor, lekkage | Vanaf €125",
    description:
      "Velux of dakraam kapot in Eindhoven? Lekkage, motor, mechanisme. Specialist alle merken. Vanaf €125. Bel 040 798 7470.",
  },
  breadcrumb: {
    home: "Home",
    diensten: "Diensten",
    current: "Velux reparatie",
  },
  hero: {
    pill: "DIENST — VELUX EN DAKRAAM",
    h1: "Velux en dakraam reparatie in Eindhoven",
    subhead:
      "Lekkende Velux, vastgelopen mechanisme, motor stuk of versleten rolgordijn? Wij herstellen alle merken dakramen — vakkundig en met 10 jaar garantie.",
    usps: [
      "Vanaf €125 mechanisme",
      "Alle merken (Velux, Fakro, Roto, Keylite)",
      "Op hoogte uitgerust",
    ],
    ctaPhone: "📞 040 798 7470",
    ctaOfferte: "Gratis offerte",
  },
  intro: {
    h2: "Velux reparatie: vaak goedkoper dan vervangen",
    p1:
      "Een dakraam staat dagelijks bloot aan regen, wind, hagel en UV-straling. Na 10 tot 15 jaar gaan onderdelen versleten: het sluitmechanisme klemt, de motor werkt niet meer, of er ontstaat lekkage rond de gootstukken.",
    p2:
      "Vervanging van het hele dakraam kost €1.500 tot €3.000 inclusief plaatsing. In de meeste gevallen is gerichte reparatie voldoende — vaak €125 tot €300 voor jaren extra levensduur.",
    p3:
      "Wij werken aan alle merken en types: kantelraam, tuimelraam, lichtkoepel en uitzetraam. Op hoogte uitgerust en gecertificeerd voor veilig werken, ook bij steile daken.",
  },
  problemen: {
    h2: "Veelvoorkomende dakraamproblemen",
    rows: [
      {
        title: "Lekkage rond dakraam",
        text: "Meestal versleten gootstukken of doorgelopen kit. Wij vervangen en dichten opnieuw af.",
      },
      {
        title: "Mechanisme vastgelopen",
        text: "Scharnier of bedieningsstang versleten. Wij vervangen of stellen bij.",
      },
      {
        title: "Motor werkt niet meer",
        text: "Elektronische sturing kapot of motor versleten. Vaak vervangen goedkoper.",
      },
      {
        title: "Raam sluit niet meer goed",
        text: "Sluitstukken ontregeld. Wij stellen opnieuw af, vaak in een half uur.",
      },
      {
        title: "Rolgordijn kapot",
        text: "Veer gebroken of doek beschadigd. Vervangen met originele onderdelen.",
      },
      {
        title: "Glas gebroken of beslagen",
        text: "Beglazing vervangen of glaseenheid lek? Nieuw isolatieglas op maat.",
      },
    ],
  },
  merken: {
    h2: "Wij werken met alle merken",
    cards: [
      {
        title: "VELUX",
        text: "GGL, GPL, GGU, INTEGRA — alle generaties",
      },
      {
        title: "FAKRO",
        text: "FTP, FTU, FYP — Pools fabricaat",
      },
      {
        title: "ROTO FRANK",
        text: "Designo R6, R8 — Duits premium",
      },
      {
        title: "KEYLITE",
        text: "Solar, manual, electric",
      },
    ],
    note:
      "Ook oudere modellen en nichemerken. Wij identificeren het type ter plaatse.",
  },
  werkwijze: {
    h2: "Onze werkwijze",
    steps: [
      { num: "01", title: "Aanvraag", text: "Bel of formulier" },
      {
        num: "02",
        title: "Diagnose",
        text: "Gratis inspectie op hoogte + offerte",
      },
      { num: "03", title: "Reparatie", text: "Vakkundig, vaak in 1 bezoek" },
      { num: "04", title: "Garantie", text: "10 jaar schriftelijk" },
    ],
  },
  prijzen: {
    h2: "Wat kost Velux reparatie?",
    note: "Excl. 21% BTW. Materialen op werkelijke kostprijs.",
    rows: [
      { service: "Diagnose + offerte", price: "Gratis", time: "30 min" },
      { service: "Mechanisme reparatie", price: "€125", time: "1u" },
      {
        service: "Motor vervangen (elektrisch)",
        price: "€185",
        time: "1-2u",
      },
      {
        service: "Lekkage gootstukken",
        price: "Vanaf €245",
        time: "2-3u",
      },
      { service: "Rolgordijn reparatie", price: "€95", time: "30-45 min" },
      { service: "Beglazing vervangen", price: "Op offerte", time: "2-3u" },
      {
        service: "Volledig dakraam vervangen",
        price: "Op offerte",
        time: "4-6u",
      },
    ],
  },
  waaromWij: {
    h2: "Waarom kiezen voor ons?",
    reasons: [
      {
        num: "01",
        title: "Specialisten in alle merken",
        text: "Velux, Fakro, Roto, Keylite",
      },
      {
        num: "02",
        title: "Op hoogte uitgerust + gecertificeerd",
        text: "Veilig werken",
      },
      {
        num: "03",
        title: "Originele onderdelen op voorraad",
        text: "Vaak in 1 bezoek klaar",
      },
      {
        num: "04",
        title: "10 jaar schriftelijke garantie",
        text: "Op werken en onderdelen",
      },
    ],
  },
  faq: {
    h2: "Veelgestelde vragen",
    items: [
      {
        q: "Werken jullie aan alle Velux-modellen?",
        a:
          "Ja, wij repareren alle generaties Velux dakramen: GGL, GPL, GGU en de INTEGRA elektrische series. Ook oudere typen uit de jaren 90 zijn geen probleem.",
      },
      {
        q: "Hoe lang duurt lekkage herstel?",
        a:
          "De meeste lekkages rond de gootstukken zijn in 2 tot 3 uur hersteld. Wij vervangen de versleten delen en dichten opnieuw af met professionele kit.",
      },
      {
        q: "Motor vervangen of repareren?",
        a:
          "Een elektrische motor is meestal goedkoper om te vervangen dan te repareren. Wij plaatsen een nieuw origineel onderdeel, vaak binnen een uur.",
      },
      {
        q: "Wat kost een nieuw dakraam?",
        a:
          "Een compleet nieuw dakraam inclusief plaatsing loopt van €1.500 tot €3.000 afhankelijk van het merk en formaat. Wij adviseren eerst of reparatie voldoende is.",
      },
      {
        q: "Is werken op hoogte niet gevaarlijk?",
        a:
          "Onze monteurs zijn gecertificeerd voor werken op hoogte en gebruiken professionele valbeveiliging en laddersystemen. Veiligheid staat voorop.",
      },
      {
        q: "Is spoedreparatie mogelijk?",
        a:
          "Bij lekkage of gebroken ruit rijden wij dezelfde dag uit. Bel 040 798 7470 voor directe planning.",
      },
    ],
  },
  interneLinks: {
    h2: "Gerelateerde diensten",
    cards: [
      {
        title: "Glas vervangen",
        url: "/glas-vervangen/",
        text: "Beglazing, HR++ en isolatieglas voor elk kozijn",
      },
      {
        title: "Kozijnreparatie",
        url: "/kozijn-reparatie/",
        text: "Vakkundige herstel van PVC, aluminium en houten kozijnen",
      },
      {
        title: "Inbraakschade",
        url: "/inbraakschade-reparatie/",
        text: "Snel herstel na inbraak of poging tot inbraak",
      },
    ],
  },
  ctaBanner: {
    h2: "Velux kapot in Eindhoven?",
    cta: "📞 Bel 040 798 7470",
  },
  offerte: {
    h2: "Vraag een gratis offerte aan",
    steps: ["Probleem", "Raamtype", "Contact"],
    step1: {
      label: "Wat is het probleem?",
      options: [
        "Lekkage",
        "Mechanisme vast",
        "Motor defect",
        "Raam sluit niet",
        "Rolgordijn kapot",
        "Glas gebroken",
        "Anders",
      ],
    },
    step2: {
      label: "Welk type dakraam?",
      options: [
        "Kantelraam",
        "Tuimelraam",
        "Lichtkoepel",
        "Uitzetraam",
        "Onbekend",
      ],
    },
    step3: {
      firstName: "Voornaam",
      lastName: "Achternaam",
      phone: "Telefoonnummer",
      email: "E-mailadres",
      address: "Adres",
      message: "Opmerkingen",
      messagePlaceholder: "Beschrijf uw situatie...",
      back: "Terug",
      next: "Volgende",
      submit: "Offerte aanvragen",
    },
    success: {
      title: "Bedankt voor uw aanvraag",
      body: "Wij nemen binnen 24 uur contact met u op.",
    },
  },
};